import { getRoles } from 'api/roleApi';

const VOICE_ADMIN_ROLE_NAME = 'Voice Admin';
const VOICE_ADMIN_ROLE_TYPE = 'ROLE';
const SUPER_ADMIN_ROLE_TYPE = 'SUPER_ADMIN';

export const isAdminAndVoiceUser = async () => {
  const roles = await getRoles();

  return roles?.result?.some(
    (el) =>
      el.role_type === SUPER_ADMIN_ROLE_TYPE ||
      (el.role_type === VOICE_ADMIN_ROLE_TYPE &&
        el.name === VOICE_ADMIN_ROLE_NAME),
  );
};
